'use client';

import { useEffect, useRef, useCallback } from 'react';

export function useReveal() {
  const ref = useRef<HTMLDivElement>(null);
  const init = useCallback(() => {
    if (!ref.current) return;
    const els = ref.current.querySelectorAll('.rv');
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            (e.target as HTMLElement).classList.add('rv-vis');
            observer.unobserve(e.target);
          }
        }),
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' },
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const observerCallback = init();
    return observerCallback;
  }, [init]);
  return ref;
}
